import Image from "next/image";
import { useArticleDetailContext } from "@/src/features/articles/detail/ArticleDetailContext";
import DateTimeHelper from "@/src/utils/helpers/DateTimeHelper";
import bgImage from "@/public/img/bg-image-10.jpg";

const ArticleBreadCrumb = () => {
  const { article } = useArticleDetailContext();

  function extractNameFromEmail(email: string): string {
    const [namePart] = email.split("@");
    const nameParts = namePart.split(".");
    const capitalizedNameParts = nameParts.map(part => part.charAt(0).toUpperCase() + part.slice(1).toLowerCase());
    return capitalizedNameParts.join(" ");
  }

  return (
    <>
      <div className="breadcrumb-image-container breadcrumb-style-max-width">
        <div className="breadcrumb-image-wrapper">
          <div className="breadcrumb-dark">
            <Image src={bgImage} alt={article.ImageAltText} width={200} height={200} />
          </div>
        </div>
        <div className="breadcrumb-content-top text-center">
          <ul className="meta-list justify-content-center mb--10">
            <li className="list-item">
              <div className="author-info">
                <span>{extractNameFromEmail(article.CreatingUser)}</span>
              </div>
            </li>
            <div className="rbt-separator"></div>
            <li className="list-item">
              <span>{article.Category.Name}</span>
            </li>
            <div className="rbt-separator"></div>
            <li className="list-item">
              <i className="feather-calendar"></i>
              <span>{DateTimeHelper.toDisplayDateTime(article.CreatingDateTime, "D MMMM, YYYY")}</span>
            </li>
          </ul>
          <h1 className="title">{article.Title}</h1>
        </div>
      </div>
    </>
  );
};

export default ArticleBreadCrumb;
